import actionTypes from '../../action-types'

export default (payload) => ({
  type: actionTypes.CUSTOMER.SET_META,
  payload,
})
